import { Injectable } from '@angular/core';

/**
 * Download the file in a browser from Blob.
 *
 * see: https://stackoverflow.com/questions/52154874/angular-6-downloading-file-from-rest-api
 */
@Injectable({
  providedIn: 'root',
})
export class FileDownloaderService {
  download(blob: Blob, filename: string) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    const newBlob = new Blob([blob], { type: blob.type });

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = globalThis.URL.createObjectURL(newBlob);

    const link = document.createElement('a');
    link.href = data;
    link.download = filename;
    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

    setTimeout(() => {
      // For Firefox, it is necessary to delay revoking the ObjectURL
      globalThis.URL.revokeObjectURL(data);
      link.remove();
    }, 100);
  }
}
